import React, { useState } from 'react';
import {
  Stack, PrimaryButton, mergeStyleSets, TextField, Checkbox, Text,
} from '@fluentui/react';
import CollapsiblePanel from '../../../shared/CollapsiblePanel';
import StackTokens from '../../../shared/StackTokens';
import Store from '../../../shared/state/Store';
import UiReducer from '../../../shared/state/UiReducer';
import ConfigReducer from '../../../shared/state/ConfigReducer';
import AppReducer from '../../../shared/state/AppReducer';
import PlaceholderError from '../../../shared/PlaceholderError';
import HelpButton from '../../../shared/help/HelpButton';

const styles = mergeStyleSets({
  button: {
    minWidth: '154px',
  },
});

export default () => {
  const [globalState, dispatch] = Store.useStore();
  const [modelJsonString, setModelJsonString] = useState(JSON.stringify(globalState.config?.model, null, 2));
  const [modelJsonStringChanged, setModelJsonStringChanged] = useState(false);
  const generalConfig = ConfigReducer.getGeneralConfig(globalState);

  React.useEffect(() => {
    setModelJsonString(JSON.stringify(globalState?.config?.model, null, 2));
  }, [globalState.config?.model]);

  if (!AppReducer.isAppLoaded(globalState)) {
    return <PlaceholderError message="No app is currently loaded" />;
  }

  return (
    <Stack style={{ marginTop: '10px' }}>
      <Stack vertical>

        <CollapsiblePanel
          title="Edit model JSON manually"
          description="This feature is available as preview and does not validate model format"
          collapsible
          collapsed
        >
          <Stack vertical tokens={StackTokens.spacing}>
            <TextField
              label="Model JSON"
              multiline
              rows={10}
              value={modelJsonString}
              onChange={(event) => {
                setModelJsonString(event.target.value);
                setModelJsonStringChanged(true);
              }}
            />

            <span>
              <PrimaryButton
                text="Apply Changes"
                onClick={() => {
                  try {
                    const json = JSON.parse(modelJsonString);
                    dispatch(ConfigReducer.setModel(json.model || json));
                    setModelJsonStringChanged(false);
                    dispatch(UiReducer.setGenericUiAttribute(UiReducer.Keys.webAppDesignerModelModified, true));
                  } catch (error) {
                    dispatch(UiReducer.uiSetErrors(['Failed to update model JSON from manual edit:', error.message]));
                  }
                }}
              // We can use this later to validate user input
              // onClick={async () => {
              //   updateModelJson({ name: 'manual.json' }, modelJsonString);
              // }}
                disabled={!modelJsonStringChanged}
                className={styles.button}
              />
            </span>

          </Stack>
        </CollapsiblePanel>

        <Stack horizontal>
          <Checkbox
            label="Calculate model from local server path"
            checked={generalConfig.serverModelPathEnabled}
            onChange={(ev, checked) => {
              const updatedConfig = { ...generalConfig };
              if (!checked) {
                delete updatedConfig.serverModelPath;
              }
              updatedConfig.serverModelPathEnabled = checked;
              dispatch(ConfigReducer.setGeneralConfig(updatedConfig));
            }}
          />
          <HelpButton styles={{ root: { marginLeft: '5px' } }} title="Local Server Model Path">
            <Text block>If advised by your server admin, you may be able to calculate your app from a model stored on the server.</Text>
            <Text block>Note that in this case you should not alter the model JSON in any way or your app configuration will likely not match the server&lsquo;s model version</Text>
          </HelpButton>
        </Stack>

        {generalConfig.serverModelPathEnabled && (
          <TextField
            label="Model path"
            value={generalConfig.serverModelPath || ''}
            onChange={(event, value) => {
              dispatch(ConfigReducer.setGeneralConfig({ ...generalConfig, serverModelPath: value }));
            }}
          />
        )}

      </Stack>
    </Stack>
  );
};
